const QUERIES = {
  USERS_LIST: 'users-list',
}
const roleQUERIES = {
  Role_LIST: 'role-list',
}

const getUserDetails = {
  Userdata: 'users-data',
}

export { QUERIES, roleQUERIES,getUserDetails }
